import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import {Typography} from '@mui/material';

const useStyles = makeStyles((theme) => ({
    contentBox: {
        borderRadius: 8,
        margin: 10,
        backgroundColor: theme.palette.mode === 'dark' ? '#313233' : '#bfc2c7',
    },
    contentTitle: {
        borderBottom: `2px solid ${theme.palette.mode === 'dark' ? '#252525' : '#ebebeb'}`,
        padding: '10px 20px',
        paddingTop: 12,
        fontWeight: 600,
    },
    contentChildren: {
        padding: '10px 20px',
    },
}));

const UserSettingContent = (props) => {
    const classes = useStyles();

    return (
        <div className={classes.contentBox}>
            <Typography variant="body1" className={classes.contentTitle}>
                {props.title}
            </Typography>

            <div className={classes.contentChildren}>
                {props.children}
            </div>
        </div>
    );
};

export default UserSettingContent;